import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import * as S from './Breadcrumbs.styles';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { BreadcrumbsProps } from '@/components/Breadcrumbs/Breadcrumbs.types';
import { buildBreadcrumbs } from '@/components/Breadcrumbs/Breadcrumbs.helpers';
import { useCurrentCategory } from '@/hooks/useCurrentCategory/useCurrentCategory';
import { useAdPathSynchronizer } from '@/hooks/useAdPathSynchronizer';
import { getCurrentCategoryPath } from '@/hooks/useCurrentCategory/useCurrentCategory.helpers';

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  hasHorizontalPadding,
  hasBg,
}) => {
  useAdPathSynchronizer();
  const {
    query: { slug },
  } = useRouter();
  const { currentCategory } = useCurrentCategory();
  const breadcrumbs = buildBreadcrumbs(currentCategory);

  if (!breadcrumbs.length) {
    const nestingLvl = getCurrentCategoryPath(slug).split('/').length;

    return (
      <S.BreadcrumbsSkeleton data-testid="breadcrumbs-skeleton-loader">
        {Array.from({ length: nestingLvl }, (_, index) => (
          <SkeletonLoader width="115px" height="18px" key={index} />
        ))}
      </S.BreadcrumbsSkeleton>
    );
  }

  return (
    <S.BreadcrumbsBox
      data-testid="breadcrumbs-box"
      $hasHorizontalPadding={hasHorizontalPadding}
      $hasBg={hasBg}
    >
      {breadcrumbs.map(({ label, link }, index) => {
        const isLast = index === breadcrumbs.length - 1;

        return (
          <React.Fragment key={label}>
            <S.BreadcrumbsLabel
              data-testid="breadcrumbs-label"
              $variant="1"
              {...(link && { as: Link, href: link })}
            >
              {label}
            </S.BreadcrumbsLabel>
            {!isLast && (
              <S.BreadcrumbsLabel $variant="1">&#x2022;</S.BreadcrumbsLabel>
            )}
          </React.Fragment>
        );
      })}
    </S.BreadcrumbsBox>
  );
};
